import { render } from "./ButtonRefferal.vue?vue&type=template&id=4059c842&scoped=true"
import script from "./ButtonRefferal.vue?vue&type=script&lang=js"
export * from "./ButtonRefferal.vue?vue&type=script&lang=js"

import "./ButtonRefferal.vue?vue&type=style&index=0&id=4059c842&scoped=true&lang=scss"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4059c842"]])

export default __exports__